import styled from 'styled-components';

const CorporatePartnerStyles = styled.div``;

export default CorporatePartnerStyles;
